// Module
var code = "<div class=\"spim\"> <input type=\"checkbox\" data-bind=\"uniform: Checked, checked: Checked\"> </div>";
// Exports
export default code;